"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const sidebar_1 = __importDefault(require("../../molecules/sidebar/sidebar"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const filters_1 = __importDefault(require("../filters"));
const tags_1 = __importDefault(require("../filters/tags"));
const AppContexts_1 = require("../../shared/AppContexts");
const memberInFilter_1 = require("./memberInFilter");
const useOnWindowClick_1 = require("../../shared/hooks/useOnWindowClick");
const MemberList_1 = require("./MemberList");
const SearchBar_1 = require("./SearchBar");
const Wrapper = styled_components_1.default.div `
  box-sizing: border-box;
  height: 100%;
  min-height: 100%;
  max-width: 280px;
  width: 266px;
  transition: width 0.4s ease;

  form {
    margin-top: 0 !important;
  }

  & > div {
    padding-bottom: 0;
  }

  [data-filters="true"] {
    position: absolute;
    width: 510px;
    top: 0;
    height: 100%;
    left: calc(100% + 1px);
    z-index: 1001;
    opacity: 1;
    transition: opacity 0.1s ease-out;
  }

  &[data-show-filters="false"] {
    [data-filters="true"] {
      z-index: -1;
      opacity: 0;
    }
  }

  [data-sidebar-content="true"] {
    grid-template-rows: min-content auto;
    display: grid;
  }

  [data-sidebar="true"] {
    width: 266px;
    background: transparent;

    h2,
    [data-sidebar-content="true"] {
      transition: opacity 0.2s ease, transform 0.4s ease;
    }
  }

  &[data-open="false"] {
    width: 40px;
    cursor: pointer;

    [data-sidebar-content="true"] {
      opacity: 0;
      transform: translateX(-100%);
      pointer-events: none;
    }

    [data-sidebar="true"] {
      position: static;
      h2,
      & > div {
        opacity: 0;
      }
    }

    & > div {
      overflow: hidden;
    }

    & form {
      pointer-events: none;
    }

    @media (min-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      [data-sidebar-close="true"] {
        left: 0;
      }
    }
  }

  [data-sidebar="true"] {
    transition: none;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    &:before {
      position: fixed;
      content: " ";
      top: 0;
      left: -200vw;
      background-color: rgba(30, 33, 32, 0.44);
      z-index: 999;
      display: block;
      width: 200vw;
      height: 100%;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    &[data-open="true"] {
      &:before {
        left: 0;
        opacity: 1;
      }
    }

    [data-opened="true"] {
      transform: translateX(0) !important;
    }

    &[data-open="false"] {
      transform: translateX(-110%);
      min-width: unset;
      [data-filters="true"] {
        display: none;
      }
    }

    [data-filters="true"] {
      position: fixed;
      width: 266px;
      left: 0;
      form {
        position: relative;
      }
    }

    [data-sidebar-content="true"] {
      transform: translateX(0) !important;
    }

    position: fixed;
    width: 266px !important;
    transition: transform 0.4s ease !important;
    transform: translateX(0);
    top: 0;
    left: 0;
    z-index: 1000 !important;
    display: block;

    h2 {
      transition: none !important;
    }

    div[data-sidebar="true"],
    form[data-visible="true"] {
      background: ${({ theme }) => theme.colors.whiteBase} !important;
      height: 100%;
      z-index: 1000;
    }
  }

  & > div {
    overflow-y: auto;
  }
  span {
    margin-left: 0;
    margin-top: 0.785rem;
  }
  form {
    margin-bottom: 0;
    &[data-form="horizontal"] div {
      margin-right: 0.5rem;
    }
  }
  button {
    font-size: 1.15rem;
    height: 36px;
    padding: 0.45rem 0.6rem;
    align-self: auto;
    div {
      margin-right: 0 !important;
      position: relative;
      top: 2px;
      background-color: transparent !important;
    }
  }
`;
const SidebarHeader = styled_components_1.default.div `
  grid-row: 1;
  padding: 0 1rem 1rem 1rem;
`;
const SidebarComponent = ({ members, isOpen = false, onMemberSelect, onFilterChange, onToggle, mobile, title, counters, appContext, availableContexts, activeMemberId, onCtxChange }) => {
    const { timeFormat } = (0, AppContexts_1.useUserSettingsContext)();
    const [t] = (0, react_i18next_1.useTranslation)();
    const [tags, setTags] = (0, react_1.useState)([]);
    const [search, setSearch] = (0, react_1.useState)("");
    const [filters, setFilters] = (0, react_1.useState)([]);
    const [showFilters, setShowFilters] = (0, react_1.useState)(false);
    const [memberListFiltered, setMemberListFiltered] = (0, react_1.useState)(members);
    const [open, setOpen] = (0, react_1.useState)(mobile ? false : isOpen);
    const sidebarWrapperRef = (0, react_1.useRef)(null);
    const removeTag = (0, react_1.useCallback)((tag) => {
        setFilters((prevFilters) => {
            return prevFilters.map((filter, _idx) => {
                if (filter.key.search(/day\[[0-9]\]/) !== -1) {
                    filter.value = filter.value === tag.value ? false : filter.value;
                }
                else if (filter.key === tag.key) {
                    filter.value = typeof filter.value == "string" ? "" : false;
                }
                return filter;
            });
        });
    }, []);
    (0, react_1.useEffect)(() => {
        setOpen(isOpen);
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        setMemberListFiltered(members);
    }, [members]);
    (0, react_1.useEffect)(() => {
        var _a;
        [...(_a = sidebarWrapperRef.current) === null || _a === void 0 ? void 0 : _a.children].forEach((child) => {
            child.scrollTop = 0;
        });
    }, [open, showFilters]);
    (0, react_1.useEffect)(() => {
        onFilterChange && onFilterChange({ search, filters: { ...filters } });
        const filterTags = [];
        filters.forEach((filter) => {
            if (filter.value === true) {
                filterTags.push(filter);
            }
            else if (filter.value && typeof filter.value == "string") {
                filterTags.push(filter);
            }
        });
        setTags(filterTags);
        setMemberListFiltered((0, memberInFilter_1.filterMemberList)(members, filters, search, timeFormat));
    }, [search, filters, members]);
    (0, react_1.useEffect)(() => {
        const member = members.find((member) => member.id === activeMemberId);
        if (!member)
            return;
        const selectedMemberCard = document.getElementById(member.id);
        selectedMemberCard === null || selectedMemberCard === void 0 ? void 0 : selectedMemberCard.scrollIntoView(true);
    }, []);
    const onWindowClick = (e) => {
        if (!e.target.closest(".filters")) {
            showFilters && setShowFilters(false);
        }
    };
    (0, useOnWindowClick_1.useOnWindowClick)(onWindowClick, [showFilters]);
    const onWrapperClick = (e) => {
        if (e.target.classList.contains("wrapper") && mobile) {
            onToggle && onToggle(false);
        }
        if (!mobile && !open) {
            onToggle && onToggle(true);
        }
    };
    const onCloseFilters = (0, react_1.useCallback)(() => setShowFilters(false), [setShowFilters]);
    const onChangeFilters = (0, react_1.useCallback)((data) => setFilters(data), [setFilters]);
    const desktopTitle = !mobile ? t("sidebar.sidebarHeader.title") : "";
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { ref: sidebarWrapperRef, "data-show-filters": !!showFilters, "data-mobile": !!mobile, "data-open": open, className: "wrapper", onClick: onWrapperClick, children: [(0, jsx_runtime_1.jsxs)(sidebar_1.default, { isMobile: mobile, isOpen: open, "data-sidebar": true, title: title || desktopTitle, onToggle: (status) => {
                    onToggle && onToggle(status);
                    setOpen(status);
                    setShowFilters(false);
                }, appContext: appContext, availableContexts: availableContexts, onCtxChange: onCtxChange, children: [(0, jsx_runtime_1.jsxs)(SidebarHeader, { children: [members.length > 0 && ((0, jsx_runtime_1.jsx)(SearchBar_1.SearchBar, { setSearch: setSearch, setShowFilters: () => setShowFilters((prevState) => !prevState), showFilters: !!onFilterChange }, void 0)), (0, jsx_runtime_1.jsx)(tags_1.default, { tags: tags, onRemove: removeTag }, void 0)] }, void 0), (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsx)(MemberList_1.MemberList, { members: memberListFiltered, onMemberClick: (member, path) => {
                            onMemberSelect && onMemberSelect(member, path);
                            setShowFilters(false);
                            mobile && onToggle && onToggle(false);
                        }, activeMemberId: activeMemberId }, void 0)), [memberListFiltered, activeMemberId])] }, void 0), (0, jsx_runtime_1.jsx)("div", { "data-filters": true, className: "filters", children: (0, jsx_runtime_1.jsx)(filters_1.default, { mobile: mobile, filters: filters, tags: tags, onRemoveTag: removeTag, counters: counters, visible: showFilters, onClose: onCloseFilters, onChange: onChangeFilters }, void 0) }, void 0)] }, void 0));
};
exports.default = (0, react_1.memo)(SidebarComponent);
//# sourceMappingURL=sidebar.js.map